import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getNewProduct } from '../../../../api/product/queries/getNewProduct';
import { INewProduct } from '../../../../interfaces/Product.interfaces';

interface IUseGetProductsQueryParams {
  searchParam: {
    category: string;
  };
}

export const useGetNewProductQuery = ({ searchParam }: IUseGetProductsQueryParams) => {
  return useQuery<INewProduct, AxiosError>(['new-product', `category=${searchParam.category}`], () =>
    getNewProduct({ searchParam }),
  );
};
